import { Grid, GridBlockId, GridBlockType } from './layout';

const OpenGridWithShowstopper: Grid = {
    '1': [
        {
            x: 0,
            y: 0,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 1,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 2,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 3,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 4,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 5,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 6,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 7,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 8,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 9,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 10,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 11,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 12,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 13,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 14,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 15,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 16,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 17,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 18,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 19,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 20,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 21,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 22,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 23,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 24,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 25,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 26,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 27,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 28,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 29,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 30,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 31,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 32,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 33,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 34,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 35,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 36,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 37,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 38,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 39,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 40,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 41,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 42,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 43,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 44,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 45,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 46,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 47,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 48,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 49,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 50,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 51,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 52,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 53,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 54,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 55,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 56,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 57,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 58,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 59,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 60,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 61,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 62,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 63,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 64,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 65,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 66,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 67,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 68,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 69,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 70,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 71,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 72,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 73,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 74,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 75,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 76,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 77,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 78,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 79,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 80,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 81,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 82,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 83,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 84,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 85,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 86,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 87,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 88,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 89,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 90,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 91,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 92,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 93,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 94,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 95,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 96,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 97,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 98,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 99,
            w: 2,
            h: 1,
        },
    ],
    '2': [
        {
            x: 0,
            y: 0,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 1,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 1,
            w: 1,
            h: 1,
        },
        {
            id: GridBlockId.SHOWSTOPPER,
            type: GridBlockType.SHOWSTOPPER,
            x: 0,
            y: 2,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 3,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 4,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 4,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 5,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 6,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 6,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 7,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 8,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 8,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 9,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 10,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 10,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 11,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 12,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 12,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 13,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 14,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 14,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 15,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 16,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 16,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 17,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 18,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 18,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 19,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 20,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 20,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 21,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 22,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 22,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 23,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 24,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 24,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 25,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 26,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 26,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 27,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 28,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 28,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 29,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 30,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 30,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 31,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 32,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 32,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 33,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 34,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 34,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 35,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 36,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 36,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 37,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 38,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 38,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 39,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 40,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 40,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 41,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 42,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 42,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 43,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 44,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 44,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 45,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 46,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 46,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 47,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 48,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 48,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 49,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 50,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 50,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 51,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 52,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 52,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 53,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 54,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 54,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 55,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 56,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 56,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 57,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 58,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 59,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 59,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 60,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 60,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 61,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 62,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 62,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 63,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 64,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 64,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 65,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 66,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 66,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 67,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 68,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 68,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 69,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 70,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 70,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 71,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 72,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 72,
            w: 1,
            h: 1,
        },
    ],
    '3': [
        {
            x: 0,
            y: 0,
            w: 2,
            h: 2,
        },
        {
            x: 2,
            y: 0,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 1,
            w: 1,
            h: 1,
        },
        {
            id: GridBlockId.SHOWSTOPPER,
            type: GridBlockType.SHOWSTOPPER,
            x: 0,
            y: 2,
            w: 3,
            h: 1,
        },
        {
            x: 0,
            y: 3,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 3,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 4,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 4,
            w: 1,
            h: 2,
        },
        {
            x: 2,
            y: 4,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 5,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 5,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 6,
            w: 2,
            h: 1,
        },
        {
            x: 2,
            y: 6,
            w: 1,
            h: 1,
        },

        {
            x: 0,
            y: 7,
            w: 2,
            h: 2,
        },
        {
            x: 2,
            y: 7,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 9,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 8,
            w: 1,
            h: 2,
        },
        {
            x: 1,
            y: 9,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 10,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 10,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 11,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 11,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 11,
            w: 1,
            h: 2,
        },
        {
            x: 0,
            y: 12,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 12,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 13,
            w: 2,
            h: 2,
        },
        {
            x: 2,
            y: 13,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 15,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 14,
            w: 1,
            h: 2,
        },
        {
            x: 1,
            y: 15,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 16,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 16,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 17,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 17,
            w: 1,
            h: 2,
        },
        {
            x: 1,
            y: 17,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 18,
            w: 2,
            h: 2,
        },
        {
            x: 0,
            y: 19,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 20,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 20,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 21,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 21,
            w: 1,
            h: 2,
        },
        {
            x: 2,
            y: 21,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 22,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 22,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 23,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 23,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 24,
            w: 2,
            h: 2,
        },
        {
            x: 2,
            y: 24,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 25,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 26,
            w: 1,
            h: 2,
        },
        {
            x: 0,
            y: 26,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 26,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 27,
            w: 1,
            h: 2,
        },
        {
            x: 1,
            y: 27,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 28,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 28,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 29,
            w: 2,
            h: 1,
        },
        {
            x: 2,
            y: 29,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 30,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 30,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 30,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 31,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 31,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 31,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 32,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 32,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 32,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 33,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 33,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 33,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 34,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 34,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 34,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 35,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 35,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 35,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 36,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 36,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 36,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 37,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 37,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 37,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 38,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 38,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 38,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 39,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 39,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 39,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 40,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 40,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 40,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 41,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 41,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 41,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 42,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 42,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 42,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 43,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 43,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 43,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 44,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 44,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 44,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 45,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 45,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 45,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 46,
            w: 1,
            h: 1,
        },
    ],
    '4': [
        {
            x: 0,
            y: 0,
            w: 2,
            h: 2,
        },
        {
            x: 2,
            y: 0,
            w: 1,
            h: 1,
        },
        {
            x: 3,
            y: 0,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 1,
            w: 2,
            h: 1,
        },
        {
            id: GridBlockId.SHOWSTOPPER,
            type: GridBlockType.SHOWSTOPPER,
            x: 0,
            y: 2,
            w: 4,
            h: 1,
        },
        {
            x: 0,
            y: 3,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 3,
            w: 1,
            h: 2,
        },
        {
            x: 2,
            y: 3,
            w: 1,
            h: 1,
        },
        {
            x: 3,
            y: 3,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 4,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 4,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 5,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 5,
            w: 2,
            h: 2,
        },
        {
            x: 3,
            y: 5,
            w: 1,
            h: 1,
        },
        {
            x: 3,
            y: 6,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 6,
            w: 1,
            h: 2,
        },
        {
            x: 1,
            y: 7,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 7,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 8,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 8,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 8,
            w: 1,
            h: 1,
        },
        {
            x: 3,
            y: 8,
            w: 1,
            h: 2,
        },
        {
            x: 2,
            y: 9,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 9,
            w: 2,
            h: 2,
        },
        {
            x: 2,
            y: 10,
            w: 1,
            h: 1,
        },
        {
            x: 3,
            y: 10,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 11,
            w: 1,
            h: 2,
        },
        {
            x: 1,
            y: 11,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 11,
            w: 2,
            h: 1,
        },
        {
            x: 1,
            y: 12,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 12,
            w: 1,
            h: 1,
        },
        {
            x: 3,
            y: 12,
            w: 1,
            h: 2,
        },
        {
            x: 0,
            y: 13,
            w: 2,
            h: 2,
        },
        {
            x: 2,
            y: 13,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 14,
            w: 1,
            h: 1,
        },
        {
            x: 3,
            y: 14,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 15,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 15,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 16,
            w: 1,
            h: 1,
        },
        {
            x: 3,
            y: 15,
            w: 1,
            h: 2,
        },
        {
            x: 1,
            y: 16,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 16,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 17,
            w: 2,
            h: 1,
        },
        {
            x: 2,
            y: 17,
            w: 1,
            h: 1,
        },
        {
            x: 3,
            y: 17,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 18,
            w: 2,
            h: 2,
        },
        {
            x: 2,
            y: 18,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 19,
            w: 1,
            h: 1,
        },
        {
            x: 3,
            y: 18,
            w: 1,
            h: 2,
        },
        {
            x: 0,
            y: 20,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 20,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 20,
            w: 1,
            h: 1,
        },
        {
            x: 3,
            y: 20,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 21,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 21,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 21,
            w: 1,
            h: 1,
        },
        {
            x: 3,
            y: 21,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 22,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 22,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 22,
            w: 1,
            h: 1,
        },
        {
            x: 3,
            y: 22,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 23,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 23,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 23,
            w: 1,
            h: 1,
        },
        {
            x: 3,
            y: 23,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 24,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 24,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 24,
            w: 1,
            h: 1,
        },
        {
            x: 3,
            y: 24,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 25,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 25,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 25,
            w: 1,
            h: 1,
        },
        {
            x: 3,
            y: 25,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 26,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 26,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 26,
            w: 1,
            h: 1,
        },
        {
            x: 3,
            y: 26,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 27,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 27,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 27,
            w: 1,
            h: 1,
        },
        {
            x: 3,
            y: 27,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 28,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 28,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 28,
            w: 1,
            h: 1,
        },
        {
            x: 3,
            y: 28,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 29,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 29,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 29,
            w: 1,
            h: 1,
        },
        {
            x: 3,
            y: 29,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 30,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 30,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 30,
            w: 1,
            h: 1,
        },
        {
            x: 3,
            y: 30,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 31,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 31,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 31,
            w: 1,
            h: 1,
        },
        {
            x: 3,
            y: 31,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 32,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 32,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 32,
            w: 1,
            h: 1,
        },
        {
            x: 3,
            y: 32,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 33,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 33,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 33,
            w: 1,
            h: 1,
        },
        {
            x: 3,
            y: 33,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 34,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 34,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 34,
            w: 1,
            h: 1,
        },
        {
            x: 3,
            y: 34,
            w: 1,
            h: 1,
        },
    ],
    '5': [
        {
            x: 0,
            y: 0,
            w: 2,
            h: 2,
        },
        {
            x: 2,
            y: 0,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 1,
            w: 1,
            h: 1,
        },
        {
            x: 3,
            y: 0,
            w: 2,
            h: 1,
        },
        {
            x: 3,
            y: 1,
            w: 1,
            h: 1,
        },
        {
            x: 4,
            y: 1,
            w: 1,
            h: 1,
        },
        {
            x: 4,
            y: 2,
            w: 1,
            h: 2,
        },
        {
            x: 3,
            y: 2,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 2,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 2,
            w: 2,
            h: 1,
        },
        {
            x: 3,
            y: 3,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 3,
            w: 2,
            h: 2,
        },
        {
            x: 0,
            y: 3,
            w: 1,
            h: 1,
        },
        {
            x: 3,
            y: 4,
            w: 1,
            h: 1,
        },
        {
            x: 4,
            y: 4,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 4,
            w: 1,
            h: 2,
        },
        {
            x: 1,
            y: 5,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 5,
            w: 2,
            h: 1,
        },
        {
            x: 4,
            y: 5,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 6,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 6,
            w: 1,
            h: 2,
        },
        {
            x: 2,
            y: 6,
            w: 1,
            h: 1,
        },
        {
            x: 3,
            y: 6,
            w: 2,
            h: 2,
        },
        {
            x: 2,
            y: 7,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 7,
            w: 1,
            h: 1,
        },
        {
            x: 4,
            y: 8,
            w: 1,
            h: 1,
        },
        {
            x: 3,
            y: 8,
            w: 1,
            h: 2,
        },
        {
            x: 2,
            y: 8,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 8,
            w: 2,
            h: 1,
        },
        {
            x: 4,
            y: 9,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 9,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 9,
            w: 1,
            h: 2,
        },
        {
            x: 0,
            y: 9,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 10,
            w: 2,
            h: 2,
        },
        {
            x: 4,
            y: 10,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 10,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 11,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 12,
            w: 1,
            h: 1,
        },
        {
            x: 4,
            y: 11,
            w: 1,
            h: 2,
        },
        {
            x: 2,
            y: 12,
            w: 1,
            h: 1,
        },
        {
            x: 3,
            y: 12,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 12,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 13,
            w: 2,
            h: 1,
        },
        {
            x: 2,
            y: 13,
            w: 1,
            h: 1,
        },
        {
            x: 3,
            y: 13,
            w: 2,
            h: 2,
        },
        {
            x: 2,
            y: 14,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 14,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 14,
            w: 1,
            h: 2,
        },
        {
            x: 1,
            y: 15,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 15,
            w: 1,
            h: 1,
        },
        {
            x: 3,
            y: 15,
            w: 1,
            h: 1,
        },
        {
            x: 4,
            y: 15,
            w: 1,
            h: 2,
        },
        {
            x: 3,
            y: 16,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 16,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 16,
            w: 2,
            h: 1,
        },
        {
            x: 0,
            y: 17,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 17,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 17,
            w: 1,
            h: 1,
        },
        {
            x: 3,
            y: 17,
            w: 1,
            h: 1,
        },
        {
            x: 4,
            y: 17,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 18,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 18,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 18,
            w: 1,
            h: 1,
        },
        {
            x: 3,
            y: 18,
            w: 1,
            h: 1,
        },
        {
            x: 4,
            y: 18,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 19,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 19,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 19,
            w: 1,
            h: 1,
        },
        {
            x: 3,
            y: 19,
            w: 1,
            h: 1,
        },
        {
            x: 4,
            y: 19,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 20,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 20,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 20,
            w: 1,
            h: 1,
        },
        {
            x: 3,
            y: 20,
            w: 1,
            h: 1,
        },
        {
            x: 4,
            y: 20,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 21,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 21,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 21,
            w: 1,
            h: 1,
        },
        {
            x: 3,
            y: 21,
            w: 1,
            h: 1,
        },
        {
            x: 4,
            y: 21,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 22,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 22,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 22,
            w: 1,
            h: 1,
        },
        {
            x: 3,
            y: 22,
            w: 1,
            h: 1,
        },
        {
            x: 4,
            y: 22,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 23,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 23,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 23,
            w: 1,
            h: 1,
        },
        {
            x: 3,
            y: 23,
            w: 1,
            h: 1,
        },
        {
            x: 4,
            y: 23,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 24,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 24,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 24,
            w: 1,
            h: 1,
        },
        {
            x: 3,
            y: 24,
            w: 1,
            h: 1,
        },
        {
            x: 4,
            y: 24,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 25,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 25,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 25,
            w: 1,
            h: 1,
        },
        {
            x: 3,
            y: 25,
            w: 1,
            h: 1,
        },
        {
            x: 4,
            y: 25,
            w: 1,
            h: 1,
        },
        {
            x: 0,
            y: 26,
            w: 1,
            h: 1,
        },
        {
            x: 1,
            y: 26,
            w: 1,
            h: 1,
        },
        {
            x: 2,
            y: 26,
            w: 1,
            h: 1,
        },
        {
            x: 3,
            y: 26,
            w: 1,
            h: 1,
        },
        {
            x: 4,
            y: 26,
            w: 1,
            h: 1,
        },
    ],
};

export { OpenGridWithShowstopper };
